import { render, staticRenderFns } from "./SearchVideoCard.vue?vue&type=template&id=77546505&scoped=true"
import script from "./SearchVideoCard.vue?vue&type=script&lang=js"
export * from "./SearchVideoCard.vue?vue&type=script&lang=js"
import style0 from "./SearchVideoCard.vue?vue&type=style&index=0&id=77546505&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77546505",
  null
  
)

export default component.exports